<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container">
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
              {{msg}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div v-if="showMsgSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
              {{msgSuccess}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form class="signin-form" v-on:submit.prevent="preventEnter">
              
              <button class="login-facebook" v-on:click.stop.prevent="loginFacebook()">Entrar com Facebook <font-awesome-icon :icon="['fab', 'facebook']" size="lg" /></button>

              <button class="login-google" v-on:click.stop.prevent="loginGoogle()">Entrar com Google <font-awesome-icon :icon="['fab', 'google']" size="lg" /></button>

              <h5>Ou</h5>

              <div class="form-group">
                <label for="emailInput">E-mail</label>
                <input v-on:keydown.enter.prevent="preventEnter" type="email" class="form-control" id="emailInput" aria-describedby="emailHelp" placeholder="Informe seu e-mail" v-model="username">
              </div>

              <div class="form-group">
                <label for="passwordInput">Senha</label>
                <input v-on:keydown.enter.prevent="preventEnter" type="password" class="form-control" id="passwordInput"  aria-describedby="passwordHelp" placeholder="Insira uma senha" v-model="password">
                <small id="passwordHelp" class="form-text text-muted"><router-link to="/forgot-password">Esqueceu a senha?</router-link></small>
              </div>

              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="true" id="defaultCheck2" v-model="persistSession">
                <label class="form-check-label" for="defaultCheck2">
                  Mantenha conectado
                </label>
              </div>

              <button type="submit" class="btn" v-on:click.stop.prevent="login()">Entrar</button>

              <h5 class="minor">Não possui conta?</h5>

              <button type="submit" class="btn btn-cadastro" v-on:click.stop.prevent="register()">Cadastre-se</button>

            </form>

          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Loading v-if="loading" message="Aguarde, autenticando..."></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faFacebookF} from '@fortawesome/fontawesome-free-brands'
import auth from '../services/auth'
import { API } from '../services/api'

export default {
  name: 'Login',
  components: {
    Header,
    Footer,
    Loading,
    FontAwesomeIcon
  },
  data () {
    return {
      username: null,
      password: null,
      persistSession: false,
      showMsg: false,
      msg: "",
      showMsgSuccess: false,
      msgSuccess: "",
      loading: false
    }
  },
  mounted(){
    if(this.$route.params.token){
      this.$http.post(API.Auth.confirmEmail, {token: this.$route.params.token}).then((res) =>{
        this.msgSuccess = res.body.message;
        this.showMsgSuccess = true;
      }, (err) => {
        this.msg = err.body.message;
        this.showMsg = true;
      });
    }
  },
  methods: {
      login () {
        //Exibe loading
        this.loading = true;
        if(this.validate()){
          this.$http.post(API.Auth.login, {username: this.username, password: this.password}).then((response) => {
            //Se usuário estiver autenticado, processa a sessão e redireciona para dashboard
            if(response.body.success == true){
              auth.setAuthToken(response.body.token);
              this.loading = false;
              if(this.$route.params.ProjectSlug){
                this.$router.push('/project/donation/' + this.$route.params.ProjectSlug);
              }else{
                this.$router.push('/dashboard');
              }
            }else{
              this.msg = response.body.message;
              this.showMsg = true;
              this.loading = false;
            }
            //Oculta loading
          }, (error) => {
            console.log(error);
            this.loading = false;
          });
        }else{

        }
      },
      loginFacebook(){
        this.loading = true;
        var $this = this;
        FB.login(function(response) {
          if (response.status == "unknown" || response.status == undefined) {
            $this.msg = 'Erro ao autenticar no Facebook.';
            $this.showMsg = true;
            $this.loading = false;
          }else {
            $this.prepareLoginFacebook((dataUser) => {
              $this.$http.post(API.Auth.loginFacebook, 
              {facebookId: dataUser.id, name: dataUser.name, email: dataUser.email, picture: dataUser.picture.data.url}).then((rtrn) => {
                if(rtrn.body.success == true){
                  auth.setAuthToken(rtrn.body.token);
                  $this.loading = false;
                  if($this.$route.params.ProjectSlug){
                    $this.$router.push('/project/' + $this.$route.params.ProjectSlug);
                  }else{
                    $this.$router.push('/dashboard');
                  }
                }else{
                  $this.msg = rtrn.body.message;
                  $this.showMsg = true;
                  $this.loading = false;
                }
              });
            });
          }
        });
      },
      loginGoogle(){
        var $this = this;
        var auth2 = gapi.auth2.getAuthInstance();
        auth2.signIn().then(
          function(response) {
            var profile = auth2.currentUser.get().getBasicProfile()
            $this.$http.post(API.Auth.loginGoogle, {
              googleId: profile.getId(), name: profile.getName(), email: profile.getEmail(), picture: profile.getImageUrl()
            }).then((rtrn) => {
              if(rtrn.body.success == true){
                  auth.setAuthToken(rtrn.body.token);
                  $this.loading = false;
                  if($this.$route.params.ProjectSlug){
                    $this.$router.push('/project/' + $this.$route.params.ProjectSlug);
                  }else{
                    $this.$router.push('/dashboard');
                  }
                }else{
                  $this.msg = rtrn.body.message;
                  $this.showMsg = true;
                  $this.loading = false;
                }
            });
          },
          function(error) {
            $this.msg = 'Erro ao autenticar no Google.';
            $this.showMsg = true;
            $this.loading = false;
          }
        );
      },
      prepareLoginFacebook(callback){
        FB.api('/me', { fields: 'id,name,email,locale,picture.type(large)' }, function(response) {
          callback(response)
        })
      },
      validate () {
        if (this.username == "" || this.username == null) {
          this.msg = 'Deve informar o seu e-mail!'
          this.showMsg = true;
          this.loading = false;
          return false;
        }
        if (this.password == "" || this.password == null) {
          this.msg = 'Deve informar a senha!'
          this.showMsg = true;
          this.loading = false;
          return false;
        }
        return true;
      },
      register()
      {
        this.$router.push('/signup');
      },
      hideMsg(){
        this.msg = "";
        this.showMsg = false;
        this.msgSuccess = "";
        this.showMsgSuccess = false;
      },
      preventEnter(e){
        e.preventDefault()
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .signin-form{
    width: 100%;
    padding: 20px;
    background-color: #eee;
    border-radius: 5px;
    margin-bottom: 40px;
    font-family: RalewayRegular;

    h5{
      position: relative;
      text-align: center;
      margin: 30px 0px;
      font-family: RalewayRegular;

      &.minor{
        font-size: 16px;
      }

      &::before{
        position: absolute;
        content: " ";
        width: 35%;
        border-bottom: 1px solid #d9d9d9;
        height: 1px;
        top: 50%;
        right: 0;
      }

      &::after{
        position: absolute;
        content: " ";
        width: 35%;
        border-bottom: 1px solid #d9d9d9;
        height: 1px;
        top: 50%;
        left: 0;
      }
    }

    small{
      a{
        font-size: 14px;
        color: #00ae39;
        font-family: RalewayBold;
        text-decoration: none;
      }
    }

    input{
      padding: 10px;
      border-color: #00ae39;
    }

    .form-check{
      padding-bottom: 10px;
    }

    button{
      width: 100%;
      margin-top: 20px;
      padding: 10px;
      font-size: 20px;
      background-color: #00ae39;
      color: #fff;
      cursor: pointer;

      &.login-facebook{
        background-color: #3b5998;
        border: none;
        border-radius: 5px;

        svg{
          margin-left: 10px;
        }
      }

      &.login-google{
        background-color: #D84B37;
        border: none;
        border-radius: 5px;

        svg{
          margin-left: 10px;
        }
      }

      &.btn-cadastro{
        margin-top: 0px;
        background-color: #fff;
        border: thin solid #00ae39;
        color: #00ae39;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue